import { DragTarget, ItemInstance } from '@headless-tree/core';
import { FileItemType } from '../../types';

type HandleMoveItemParamsType = {
  fileId: string;
  newParentId: string;
};

type HandleDropItemReturnType<T> = (
  items: ItemInstance<T>[],
  newChildren: DragTarget<T>
) => void;
export const handleDrop = <T extends FileItemType>(
  onMoveItem: (params: HandleMoveItemParamsType) => void
): HandleDropItemReturnType<T> => {
  return (items: ItemInstance<T>[], newChildren: DragTarget<T>): void => {
    if (items.length > 0) {
      onMoveItem({
        fileId: items[0].getId(),
        newParentId: newChildren.item.getId(),
      });
    }
  };
};
